import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom-v5-compat';
import { FormattedMessage } from 'react-intl';

import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { pages } from '../../../pages/settings/nav-items';
import { messages } from '../../../components/shipping-grid/messages';

export const RefundAssistDisabledPlaceholder = () => {
  const navigate = useNavigate();

  const handleEnableRefundAssist = useCallback(() => {
    navigate(`/${pages.settings.location}/${pages.refundAssist.location}`);
  }, [navigate]);

  return (
    <ActionablePlaceholder
      action={handleEnableRefundAssist}
      buttonContent={<FormattedMessage {...messages.refundAssistDisabledPlaceholderButtonText} />}
      description={<FormattedMessage {...messages.refundAssistDisabledPlaceholderDescription} />}
      title={<FormattedMessage {...messages.refundAssistDisabledPlaceholderTitle} />}
    />
  );
};
